import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute  } from '@angular/router';

import { AuthenticationService, CommonService } from './../../services/index';
import { app_version } from './../../../environments/version';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    model: any = {};
    isLoading = false;
    returnUrl: string;
    alert: any = null;
    version: string;
    test: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.version = app_version;
}

  signup() {
    this.router.navigate(['/signup']);
  }

  login() {
    // re-direct to authr login
    const authrLoginUrl = CommonService.getAuthrLoginUrl();

    this.authenticationService.logout();

    const returnUrl = encodeURIComponent(location.origin + '/#/tokenLogin');

    console.log(returnUrl);

    const loc = `${authrLoginUrl}?postAuthRedirect=` + returnUrl;

    console.log(loc);

    window.location.replace(loc);

  }
}
